import { Share } from '@capacitor/share';
import { esApp } from './plataforma';

export interface DatosACompartir {
	title?: string;
	text?: string;
	url?: string;
}

/**
 * Abrir el menú de compartir.
 *
 * En el navegador del móvil es `navigator.share`. Dentro de la app ese menú no existe —el WebView
 * de Android no lo trae— y la llamada fallaba en silencio: el botón «Compartir» no hacía nada.
 * Ahí se usa el menú del sistema.
 *
 * Si el usuario lo cierra sin elegir nada, la promesa se rechaza en los dos casos; quien llama
 * decide si eso le importa.
 */
export const compartir = async (datos: DatosACompartir): Promise<void> => {
	if (esApp()) {
		await Share.share(datos);
		return;
	}

	await navigator.share(datos);
};
